(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".accordion-header").forEach(header => {
    header.addEventListener("click", function () {
      let target = document.getElementById(this.dataset.acc);

      document.querySelectorAll(".accordion-body").forEach(body => {
        if (body !== target) body.style.maxHeight = null;
      });
      document.querySelectorAll(".acc-icon").forEach(icon => {
        if (icon !== this.querySelector(".acc-icon")) icon.textContent = "+";
      });

      if (target.style.maxHeight) {
        target.style.maxHeight = null;
        this.querySelector(".acc-icon").textContent = "+";
      } else {
        target.style.maxHeight = target.scrollHeight + "px";
        this.querySelector(".acc-icon").textContent = "-";
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
